import Loadable from "app/components/Loadable";
import { lazy } from "react";

const MonthlyPlanList = Loadable(lazy(() => import("./MonthlyPlanList")));
const MonthlyPlanForm = Loadable(lazy(() => import("./MonthlyPlanForm")));

const monthlyPlanRoutes = [
  {
    path: "/MonthlyPlan/MonthlyPlanList",
    element: <MonthlyPlanList />,
  },
  {
    path: "/MonthlyPlan/MonthlyPlanForm",
    element: <MonthlyPlanForm />,
  },
  {
    path: "/MonthlyPlan/MonthlyPlanForm/:monthlyPlanId",
    element: <MonthlyPlanForm />,
  },
];

export default monthlyPlanRoutes;
